import { useEffect } from 'react'
import { useAuth } from 'react-oidc-context'

import { useAuthStore } from '@/stores/auth-store'

export function TokenMonitor() {
  const auth = useAuth()
  const { setShowExpiryWarning } = useAuthStore()

  useEffect(() => {
    const handleSilentRenewError = (error: Error) => {
      console.error('[TokenMonitor] Silent renew error:', error)
      setShowExpiryWarning(true)
    }

    auth.events.addSilentRenewError(handleSilentRenewError)

    return () => {
      auth.events.removeSilentRenewError(handleSilentRenewError)
    }
  }, [auth.events, setShowExpiryWarning])

  return null
}
